import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

export function useProducts({
    onArchived = () => {},
    onRestored = () => {},
    onError = () => {},
}) {
    const $toast = useToast()

    const archiving = ref(false)
    const restoring = ref(false)

    const archiveProduct = async (id) => {
        try {
            archiving.value = true
            await axios.delete(`/api/products/${id}`)
            onArchived()
        } catch (error) {
            onError(error)
        } finally {
            archiving.value = false
        }
    }

    const restoreProduct = async (id) => {
        try {
            restoring.value = true
            await axios.post(`/api/products/${id}/restore`)
            $toast.success('Produit restauré', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            })
            onRestored()
        } catch (error) {
            onError(error)
        } finally {
            restoring.value = false
        }
    }

    return {
        archiving,
        restoring,
        archiveProduct,
        restoreProduct,
    }
}
